import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthService } from '../../../shared/services/index';

@Component({
    templateUrl: './login.page.html',
    standalone: false
})
export class LoginPageComponent implements OnInit {
  isLoginFailed = false;
  loginForm: UntypedFormGroup;
  loading = false;

  public ssoEnabled = false;

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.loginForm = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.required),
      password: new UntypedFormControl('', Validators.required)
    });
    this.ssoEnabled = window['ssoEnabled'];
  }

  onSubmit(form: UntypedFormGroup) {
    this.loading = true;
    this.authService.login(form.value).subscribe((res) => {
      this.loading = false;
      this.isLoginFailed = res.status !== 200 ? true : false;
      if (!this.isLoginFailed) {
        this.router.navigateByUrl('/');
      }
    });
  }

  public bobstAccess() {
    window.location.href = '/accountsaml/login';
  }
}
